import { FormattedMessage } from "react-intl";
import { Row, Col, Typography } from "antd";

const { Title, Paragraph } = Typography;

const Welcome = () => (
  <Row>
    <Col>
      <Title className="center">
        <FormattedMessage
          id="welcome.title"
          defaultMessage="Vítejte v nástroji pro online komunikaci se společností DHL Freight CZ"
        />
      </Title>
      <Paragraph className="center">
        <FormattedMessage
          id="welcome.text"
          defaultMessage="Společnost DHL Freight nyní nabízí pro registrované zákazníky možnost uzavřít smlouvu o přepravě věcí online, bez nutnosti kontaktovat zákaznický servis. Díky tomu je objednání přepravy vašich zásilek snazší a pohodlnější, než kdykoli předtím. Jednoduše se zaregistrujte a začněte posílat své zásilky prostřednictvím naší zcela digitální platformy."
        />
      </Paragraph>
    </Col>
  </Row>
);

export default Welcome;
